import {
  GenericFileDropzoneInput,
  GenericFileDropzoneInputProps,
} from '@components/file-dropzone/generic-file-dropzone-input';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFileDropzoneProps<T> = FormFieldProps<GenericFileDropzoneInputProps, T>;

export function FormFileDropzone<T>(props: FormFileDropzoneProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'file' });

  return <GenericFileDropzoneInput {...props} {...formFieldProps} />;
}
